<template>
<form @submit.prevent="submit" id="gateway_form" class="bg-white">

    <div class="container p-3 pt-5 my-4 border in-border-header">
        <kt-form-section is_first>
            <div class="section-header bg-white">
                {{ $t('label.complete_personal_data') }}
            </div>
            <kt-row>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="merchant_type">
                            {{ $t('label.merchant_type') }}
                        </kt-form-label>
                        <select
                                id="merchant_type"
                                name="merchant_type"
                                v-model="form_data.merchant_type"
                                class="form-control kt-selectpicker"
                        >
                            <option value=0>
                                {{ $t('label.real') }}
                            </option>
                            <option value=1>
                                {{ $t('label.legal') }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row v-if="form_data.merchant_type == 1">
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="com_name_fa">
                            {{ $t('label.com_name_fa') }}
                        </kt-form-label>
                        <kt-form-control
                                id="com_name_fa"
                                name="com_name_fa"
                                v-model="form_data.com_name_fa"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="com_name_en">
                            {{ $t('label.com_name_en') }}
                        </kt-form-label>
                        <kt-form-control
                                id="com_name_en"
                                name="com_name_en"
                                dir="ltr"
                                v-model="form_data.com_name_en"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="national_legal_code">
                            {{ $t('label.national_legal_code') }}
                        </kt-form-label>
                        <kt-form-control
                                id="national_legal_code"
                                name="national_legal_code"
                                v-model="form_data.national_legal_code"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="6">
                    <kt-form-group>
                        <kt-form-label for="register_number">
                            {{ $t('label.register_number') }}
                        </kt-form-label>
                        <kt-form-control
                                id="register_number"
                                name="register_number"
                                v-model="form_data.register_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="register_date">
                            {{ $t('label.com_register_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="register_date"
                                name="register_date"
                                v-model="form_data.register_date" type="date" />
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
    </div>

    <div class="container p-3 pt-5 my-4 border in-border-header">
        <kt-form-section>
            <div class="section-header bg-white">
                {{ $t('label.shop_data') }}
            </div>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="farsi_name">
                            {{ $t('label.farsi_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="farsi_name"
                                name="farsi_name"
                                v-model="form_data.farsi_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="english_name">
                            {{ $t('label.english_name') }}
                        </kt-form-label>
                        <kt-form-control
                                id="english_name"
                                name="english_name"
                                v-model="form_data.english_name"
                                dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <div class="col-12">
                    <kt-form-group>
                        <kt-form-label for="subcategory_code">
                            {{ $t('label.subcategory_code') }}
                        </kt-form-label>
                        <select
                                id="subcategory_code"
                                name="subcategory_code"
                                v-model="form_data.subcategory_code"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="subcategory.key"
                                    v-for="subcategory in subcategories"

                                    :value="subcategory.key"
                            >
                                {{ subcategory.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </div>
            </kt-row>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="address">
                            {{ $t('label.address') }}
                        </kt-form-label>
                        <select
                                v-if="addresses"
                                id="address"
                                name="address"
                                v-model="form_data.address"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="address.id"
                                    v-for="address in addresses"

                                    :value="address.id"
                            >
                                {{ address.address }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="telephone"
                                name="telephone"
                                v-model="form_data.telephone"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="sheba_number">
                            {{ $t('label.sheba_number') }}
                        </kt-form-label>
                        <select
                                id="sheba_number"
                                name="sheba_number"
                                v-model="form_data.sheba"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="sheba_number.id"
                                    v-for="sheba_number in sheba_numbers"

                                    :value="sheba_number.id"
                            >
                                {{ sheba_number.number }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="site_address">
                            {{ $t('label.site_address') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="site_address"
                                name="site_address"
                                placeholder="https://mysite.ir/"
                                v-model="form_data.site_address">
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="wage">
                            {{ $t('label.wage') }}
                        </kt-form-label>
                        <select
                                id="wage"
                                name="wage"
                                v-model="
                            (
                                form_data.merchant_share_percent != 0 &&
                                form_data.merchant_share_percent != 100
                            ) ?
                            wage_s = 50:
                            form_data.merchant_share_percent"
                                @change="selectChange($event)"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-for="wage in wages"
                                    v-bind:key="wage.id"
                                    :value="wage.id"
                            >
                                {{ wage.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>

                <kt-col v-if="(
                    form_data.merchant_share_percent != 0 &&
                    form_data.merchant_share_percent != 100
                )" lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="merchant_wage_share">
                            {{ $t('label.merchant_wage_share') }}
                        </kt-form-label>
                        <input
                                type="number"
                                max="100"
                                min="0"
                                id="merchant_share_percent"
                                name="merchant_share_percent"
                                v-model="form_data.merchant_share_percent"
                                class="form-control kt-selectpicker"
                        >
                    </kt-form-group>
                </kt-col>

                <kt-col v-if="(
                    form_data.merchant_share_percent != 0 &&
                    form_data.merchant_share_percent != 100
                )" lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="client_wage_share">
                            {{ $t('label.client_wage_share') }}
                        </kt-form-label>

                        <p
                                class="form-control disabled"
                                id="client_wage_share"
                                name="client_wage_share"
                        >
                            {{ !form_data.merchant_share_percent ? "" : 100 - form_data.merchant_share_percent }}
                        </p>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label>
                            {{ $t('label.logo') }}
                        </kt-form-label>
                        <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                            <kt-icon type="fa" name="paperclip"></kt-icon>
                            {{ $t('gateway.btn.click_me') }}
                        </kt-form-label>
                        <input
                                @change="processLogoFile"
                                type="file"
                                class="custom-file-upload"
                                name="logo"
                                id="logo_file"
                                accept="image/png"
                        />
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
        <kt-form-action class="mt-4">
            <kt-button
                    class="m-2"
                    size="md"
                    variant="success"
                    type="submit"
                    v-bind:wide="true"
                    id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </div>

</form>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            subcategories: subcategories,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ]
        }
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetch')
        .finally(() => {
            Object.keys(this.sheba_numbers).map(key => {
                let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                this.sheba_numbers[key]['number'] = number
            })
        })
        this.$store.dispatch('address/fetch').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })

            document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        selectChange(event){
            if (event.target.value == 0 || event.target.value == 100)
            this.form_data.merchant_share_percent = event.target.value
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('authenticate.hint.fourth'));
                $(file).val('');
            } else {

            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'png':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
            }
        }
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ])
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>